import axios from 'axios';

// Base URL for API - can be configured via environment variables
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Create axios instance with default configurations
 */
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor to add auth token to all requests
 */
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('authToken');
    
    // If token exists, add it to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor to handle common errors
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - clear token and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      // Use window.location as fallback for interceptor
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

// Auth API calls
export const authAPI = {
  /**
   * Login user
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise} User data with token
   */
  login: (email, password) => api.post('/auth/login', { email, password }),
};

// Tickets API calls
export const ticketAPI = {
  /**
   * Create a new ticket
   * @param {Object} ticketData - Ticket data (title, description, priority)
   * @returns {Promise} Created ticket
   */
  create: (ticketData) => api.post('/tickets', ticketData),
  
  /**
   * Get all tickets (filtered by role)
   * @returns {Promise} List of tickets
   */
  getAll: () => api.get('/tickets'),
  
  /**
   * Update ticket status (Admin only)
   * @param {string} id - Ticket ID
   * @param {string} status - New status (Open, In Progress, Resolved)
   * @returns {Promise} Updated ticket
   */
  updateStatus: (id, status) => api.put(`/tickets/${id}`, { status }),
};

export default api;